import "../i18n";
import "../sentryInstrumentReact";
import React from 'react';

import { useCart } from './CartContext';

function StoreHeader({h1Text, totalItems, headerType}) {
  const { cartSubtotal } = useCart();
  const formattedSubtotal = parseFloat(cartSubtotal).toLocaleString('en-US', {style: 'currency', currency: 'USD'});
  const formattedTotalItems = parseInt(totalItems).toLocaleString('en-US');

  return (
    <header className={`${headerType}-header`}>
      <div className="container">
        <div className="title-subtotal">
          <h1>
            
              {headerType === "checkout" ? 
                <svg className="icon icon--xl" xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
                  <path d="M80 16C62.3 16 48 30.3 48 48V80c0 17.7 14.3 32 32 32h88 16 88c17.7 0 32-14.3 32-32V48c0-17.7-14.3-32-32-32H80zM272 128H184v32H424.5c31.8 0 58.9 23.4 63.4 54.9l23.5 164.5c.4 3 .6 6 .6 9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V388.5c0-3 .2-6.1 .6-9L24.2 214.9C28.7 183.4 55.7 160 87.5 160H168V128H80c-26.5 0-48-21.5-48-48V48C32 21.5 53.5 0 80 0H272c26.5 0 48 21.5 48 48V80c0 26.5-21.5 48-48 48zM168 176H87.5c-23.9 0-44.1 17.6-47.5 41.2L16.5 381.8c-.1 .7-.2 1.5-.3 2.2H495.8c-.1-.7-.2-1.5-.3-2.2L472 217.2c-3.4-23.6-23.6-41.2-47.5-41.2H184 168zM16 400v48c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V400H16zM128 240a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm80 16a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm128-64a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm128-64a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM96 56H256c4.4 0 8 3.6 8 8s-3.6 8-8 8H96c-4.4 0-8-3.6-8-8s3.6-8 8-8z"/>
                </svg>
                :
                <svg className="icon icon--xl" height="16" width="14" viewBox="0 0 448 512">
                  <path d="M144 96v32H304V96c0-44.2-35.8-80-80-80s-80 35.8-80 80zm-16 48H48c-17.7 0-32 14.3-32 32V416c0 44.2 35.8 80 80 80H352c44.2 0 80-35.8 80-80V176c0-17.7-14.3-32-32-32H320v88c0 4.4-3.6 8-8 8s-8-3.6-8-8V144H144v88c0 4.4-3.6 8-8 8s-8-3.6-8-8V144zm0-16V96c0-53 43-96 96-96s96 43 96 96v32h80c26.5 0 48 21.5 48 48V416c0 53-43 96-96 96H96c-53 0-96-43-96-96V176c0-26.5 21.5-48 48-48h80z"/>
                </svg>
              }
            {h1Text}
          </h1>
          {(headerType === "cart" && totalItems >= 1) &&
            <div className="subtotal">
              {window.gettext("Cart Total")}
              <span className="hidden-mobile"> ({formattedTotalItems} {window.gettext("Items")})</span>:&nbsp; 
              <strong className="subototal">{formattedSubtotal}</strong>
            </div>
          }
          {(headerType === "checkout" && totalItems >= 1) && 
          <nav role="navigation">
          <a href={window.gettext("/store/cart/")} className="btn btn-sm">&larr; {window.gettext("Back to Cart")}</a>
          </nav>
          } 
        </div>
      </div>
      
    </header>
  );
}

export default StoreHeader;
